import { User } from 'firebaseFunctions/types'

export const mockUserA: User = {
  email: 'mockUserA@mailinator.com',
  displayName: 'MOCK_USER_A_ID',
  emailVerified: true,
  photoURL: 'https://lh3.googleusercontent.com/-8GlWPXK3a3M/AAAAAAAAAAI/AAAAAAAAAAA/ACHi3rdOaEksVzZdY2WYvkojCNy6CCj8Hg.CMID/s64-c/photo.jpg',
}
